import React from 'react';

const Label = ({children,require}) => {
    return (
        <div className="mb-2 font-bold">
            {children}
            {require&&<span className="text-red-600 ml-1">*</span>}
        </div>
    )
}

export default Label